import { useNavigation } from '../middleware/Navigation.jsx';
import { useState } from 'react';
import '../styles/Cart.css';

export default function CartProduct({ item, cart }) {
    const navigate = useNavigation();
    const [isRemoving, setIsRemoving] = useState(false);
    const [imageError, setImageError] = useState(false);

    const Remove = (event) => {
        event.stopPropagation();
        setIsRemoving(true);
        
        // Add a small delay to show the removal animation
        setTimeout(() => {
        cart.RemoveFromCart(event, item.id);
        }, 300);
    }

    // Commenting out unused function
    // const Add = (event) => {
    //     cart.AddToCart(event, item);
    // }

    const ViewProduct = () => {
        navigate(`/contract/${item.handle}`);
    }

    // Get the first image URL from the item if available
    const getImageUrl = () => {
        if (item.images && item.images.edges && item.images.edges.length > 0) {
            return item.images.edges[0].node.url;
        }
        if (item.image) {
            return item.image;
        }
        return '/images/contract.png'; // Fallback to default image
    }

    const handleImageError = () => {
        setImageError(true);
    }

    return (
        <div className={`cart-product ${isRemoving ? 'removing' : ''}`} onClick={ViewProduct}>
            <div className="cart-product-image">
                {imageError ? (
                    <div className="cart-product-placeholder">
                        <img src="/images/contract.png" alt={item.title} />
                    </div>
                ) : (
                    <img 
                        src={getImageUrl()} 
                        alt={item.title} 
                        onError={handleImageError}
                    />
                )}
            </div>
            <div className="cart-product-details">
                <h3 className="cart-product-title">{item.title}</h3>
                <p className="cart-product-description">Lawyer-grade contract template</p>
                <div className="cart-product-actions">
                    <button 
                        className="remove-btn" 
                        onClick={(e) => {
                            e.stopPropagation();
                            Remove(e);
                        }}
                        disabled={isRemoving}
                    >
                        {isRemoving ? 'Removing...' : 'Remove'}
                    </button>
                </div>
            </div>
            <div className="cart-product-price">
                <span>Calculated at checkout</span>
            </div>
    </div>
    );
}